import ReminderTranslationResponse from '../../../../../Spirit/Admin/Interfaces/Models/ReminderService/ReminderTranslationResponse';

export default class ReminderCreateRequest {
	Translations: Array<ReminderTranslationResponse> = null;
	constructor(obj?: Partial<ReminderCreateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
